import { render, staticRenderFns } from "./SGPGridBoxComponent.vue?vue&type=template&id=153da324&scoped=true"
import script from "./SGPGridBoxComponent.vue?vue&type=script&lang=js"
export * from "./SGPGridBoxComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPGridBoxComponent.vue?vue&type=style&index=0&id=153da324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153da324",
  null
  
)

export default component.exports